module.exports = __webpack_public_path__ + "img/doceree_plugin.d663669c.svg";